export default __webpack_public_path__ + "static/media/LINE_logo.5ef07042.png";